const router = [
  {
    name: 'cashier_index',
    path: '',
    component: () => import('../view/cashier/index'),
    meta: {
      title: '收银',
      ico: 'el-icon-s-finance',
      isShow: true,
      authkey: ''
    }
  },
  {
    name: 'cashier_hold',
    path: 'hold',
    component: () => import('../view/cashier/hold'),
    meta: {
      title: '挂单',
      ico: 'el-icon-tickets',
      isShow: true,
      authkey: ''
    }
  },
  {
    name: 'cashier_order',
    path: 'order',
    component: () => import('../view/cashier/order'),
    meta: {
      title: '订单',
      ico: 'el-icon-s-order',
      isShow: true,
      authkey: ''
    }
  },
  {
    name: 'cashier_verify',
    path: 'verify',
    component: () => import('../view/cashier/verify'),
    meta: {
      title: '核销',
      ico: 'el-icon-finished',
      isShow: true,
      authkey: ''
    }
  }
]

export default router
